// src/components/PortfolioHeader.js
import React from "react";
import "./PortfolioHeader.css";
import { Button } from "./Button";
import { Link } from "react-router-dom";

function PortfolioHeader() {
  return (
    <header className="portfolio-header">
      <h1>Our Portfolio</h1>
      <p>
        Explore our work in 360° virtual tours, drone cinematography,
        photography, and video production. Every project is designed to showcase
        properties with clarity, sophistication, and impact.
      </p>
      <br></br>
      <div className="header-cta">
        <Link to="/contact">
          <Button
            className="btn-mobile"
            buttonStyle="btn--outline"
            buttonSize="btn--large"
          >
            Book a Shoot
          </Button>
        </Link>
      </div>
    </header>
  );
}

export default PortfolioHeader;
